import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import axios from "axios"

import { useBaseContext } from "contexts/use-base-context"

import { getCurrentUserCookie } from "utils/cookies"

/**
 * Custom hook for handling admin authentication
 * Sets up JWT authorization headers when admin mode is enabled and user is authenticated
 */
export const useAuthentication = () => {
  const [searchParams] = useSearchParams();
  const { setIsAdmin } = useBaseContext();

  useEffect(() => {
    const userData = getCurrentUserCookie();
    const hasAdminParam = searchParams.get("isAdmin") === "true";

    if (userData?.jwt && hasAdminParam) {
      axios.defaults.headers.common["Authorization"] = `JWT ${userData.jwt}`;
      setIsAdmin(true);
    }
  }, [setIsAdmin, searchParams])
}